import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type { UserListUserActivitiesParams } from '../api'
import { getListUserActivitiesOptions } from './user-activity.options'

export const useUserActivity = (params: UserListUserActivitiesParams) => {
  return useQuery(getListUserActivitiesOptions(params))
}

export const usePrefetchListUserActivities = (
  params: UserListUserActivitiesParams,
) => {
  return useSuspenseQuery(queryOptions(getListUserActivitiesOptions(params)))
}
